import React, { useContext } from 'react';
import { Link as GatsbyLink } from 'gatsby';
import LocaleContext from '../context/locale';

// Fine tune this on project needs
const INTERNAL_REGEX = new RegExp(`^/(?!/)`);

const prefixMap = {
  'it-IT': '',
  'en-US': '/en',
};

const GlobalLink = ({
  to,
  target,
  children,
  localize = true,
  forceOpenToSelf = false,
  ...props
}) => {
  const { langCode = 'it-IT' } = useContext(LocaleContext);

  if (INTERNAL_REGEX.test(to) && target !== '_blank') {
    const { className, activeClassName, partiallyActive, style, activeStyle } =
      props;

    // Gestione activeClassName indipendente da slash finale o meno
    const getProps = ({ href, location }) => {
      const pathname = location.pathname;
      let active =
        partiallyActive &&
        pathname.startsWith(href.endsWith('/') ? href : `${href}/`);
      if (!active) {
        const strippedHref = href.endsWith('/')
          ? href.substring(0, href.length - 1)
          : href;
        const strippedPathname = pathname.endsWith('/')
          ? pathname.substring(0, pathname.length - 1)
          : pathname;
        active = strippedHref === strippedPathname;
      }
      if (active) {
        return {
          className: [className, activeClassName].filter(Boolean).join(' '),
          style: { ...style, ...activeStyle },
        };
      }
      return null;
    };
    const prefix = localize ? prefixMap[langCode] : '';
    const localizedTo =
      (prefix && !to?.startsWith(prefix + '/') ? prefix : '') +
      (to.endsWith('/') || to.includes('#') ? to : to + '/');
    return (
      <GatsbyLink
        getProps={getProps}
        to={localizedTo}
        target={target}
        {...props}
      >
        {children}
      </GatsbyLink>
    );
  }
  // Remove activeClassName prop from external links
  const { activeClassName, ...other } = props;
  const targetTo =
    forceOpenToSelf || to?.startsWith('#') || target === '_self'
      ? '_self'
      : '_blank';
  return to ? (
    <a href={to} {...other} target={targetTo} rel='noopener noreferrer'>
      {children}
    </a>
  ) : (
    <span {...other}>{children}</span>
  );
};

export const Link = GlobalLink;
